export default {
    url: '/forms',
    template: '<ui-view></ui-view>',
    abstract: true,
    data: {
        canAccess: (AuthService, PrivilegeService) => {
            return PrivilegeService.canManageForms() || PrivilegeService.canManageValidations();
        }
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/forms/index.js